
// import { Routes, Route } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


import CertifiedBankCardHomePage_ACTIVE from "./CertifiedBankCardHomePage_v02";
import CertifiedBankCardTermsOfServicePage_v01 from "./CertifiedBankCardTermsOfServicePage_v01";
import CertifiedBankCardPrivacyPolicyPage_v01 from "./CertifiedBankCardPrivacyPolicyPage_v01";


import FlashCardQuizApp_v01 from '../../QuizApp2026/QuizAppPage_v01';

export default function App() {
  return (
    <Router>
        <Routes>
        <Route path="/" element={<CertifiedBankCardHomePage_ACTIVE />} />
        <Route path="/terms-of-service" element={<CertifiedBankCardTermsOfServicePage_v01 />} />
        <Route path="/privacy-policy" element={<CertifiedBankCardPrivacyPolicyPage_v01 />} />

        <Route path="/quiz" element={<FlashCardQuizApp_v01 />} />
        </Routes>
    </Router>
  );
}